import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import Button from '../UI/button/Button';
import { auth } from '../../config/firebase';

import './Login.css';

const Login = ({history}) => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    let onSubmitHandler = (event) => {
        event.preventDefault();
        auth.signInWithEmailAndPassword(email,password)
        .then(() => history.push('/upload/cinecomaidin/admin-access'))
        .catch(err => {
            alert(err.message);
            setPassword("");
        });

    }

    return (
        <div className="login">
            <p className="login-title">LOGIN</p>
            <div className="login-form">
                <form onSubmit={onSubmitHandler}>
                    <input className="login-input"
                    placeholder="Email" 
                    type="email"
                    autoFocus
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)} /> <br/>

                    <input className="login-input"
                        placeholder="Password" 
                        type="password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} /> <br/>

                    <Button  type="submit">Submit</Button>
                </form>
            </div>
        </div>
    );
};

export default withRouter(Login);


// WEBPACK FOOTER //
// ./src/components/login/Login.js